<template>
  <div class="mt-2">
    <!--Footer and Collapsed Buttons-->
    <button-list
      v-if="hasCollapsedActions || hasFooterButtons"
      :button-list-type="'footer'"
      :button-options="buttons"
      :list-collapsed-button="isCollapsed"
      :is-collapsed="isCollapsed"
      :popup-title="popupTitle"
      @change="onEventChange"
    />
    <!--Mongo list Footer Buttons-->
    <button-list
      v-if="showMongoFooterButtons"
      :button-list-type="'footer'"
      :button-options="mongoButtons"
      :button-style="'el-button'"
    />
  </div>
</template>

<script>
import ButtonList from './buttonList/ButtonList'
import mixinListRest from '../../utils/mixin-list-rest'
import mixinListCommon from '../../utils/mixin-list-common'
import { cloneDeep, get, isArray, pickBy, unionBy } from 'lodash'

export default {
  name: 'ListButtonContainer',
  mixins: [mixinListRest, mixinListCommon],
  components: {
    ButtonList,
  },
  data() {
    return {
      exportEndpointUrl: '',
      fileImportId: `importFile-${this.getId}`,
    }
  },
  computed: {
    buttons() {
      const footerButtons = this.parseButtons(this.footerButtons)
      const collapsedButtons = this.parseButtons(this.collapsedActions)
      return unionBy(footerButtons, collapsedButtons, 'url')
    },
    buttonsParameters() {
      return {
        docMTNList: this.docMTNList,
        formId: this.mongoId,
        queryId: this.queryId,
        mongoList: JSON.stringify(this.mongoList),
        primaryKey: this.primaryKey,
        controllerName: this.getControllerName,
        showDetails: this.showDetails,
        panelId: this.panelId,
      }
    },
    collapsedButtons: {
      get() {
        return this.$get('collapsedButtons')
      },
      set(collapsedButtons) {
        this.$dispatch('setCollapsedButtons', { collapsedButtons })
      },
    },
    /**
     * @description Actions related to an Instance
     * @returns {*[]}
     */
    collapsedActions() {
      return get(this.collapsedButtons, 'functions', [])
    },
    getControllerName() {
      if (this.isInDashboard && !this.controllerName) {
        return
      }
      if (!this.controllerName && window.CORE && window.CORE.requestController && !this.isRelationshipList) {
        return window.CORE.requestController
      }
      return this.controllerName
    },
    getId() {
      return this.mongoId || this.queryId || null
    },
    /**
     * @description Actions declared for a mongo list
     * @returns {*[]}
     */
    mongoButtons() {
      return get(this.mongoList, 'footerbuttons', [])
    },
    /**
     * @description Id of the instance on an update page
     * @returns {any}
     */
    primaryKey() {
      return get(this.$route, ['query', this.$get('primaryKey')], null)
    },
  },
  methods: {
    async buttonsLoad() {
      if (!this.buttonsParameters.primaryKey) {
        return { functions: [] }
      }
      const { body } = await this.getButtonList(this.buttonsParameters)
      if (!body.data) {
        body.data = { functions: [] }
      }
      body.data.functions = body.data.functions.map((button) => {
        if (button.type === 'nodeProcess') {
          const hasNoApiBasePathInUrl = button.url.indexOf(window.CORE.apiBasePath) === -1
          if (hasNoApiBasePathInUrl) {
            button.url = `${window.CORE.apiBasePath}${button.url}`
          }
        }
        return button
      })
      return body
    },
    onEventChange({ externalType, url }) {
      if (externalType && externalType === 'export') {
        //Safari allows only direct user interaction on file uploads for security reasons
        document.getElementById(this.fileImportId).click()
        this.exportEndpointUrl = url
      }
    },
    parseButtons(footerItems) {
      let footerButtons = cloneDeep(footerItems)
      if (Array.isArray(this.buttonOverrides)) {
        this.buttonOverrides.forEach((extendedOptionsButton) => {
          footerButtons.forEach((footerButton) => {
            if (extendedOptionsButton.selector && footerButton.url.includes(extendedOptionsButton.selector)) {
              const filteredOption = pickBy(extendedOptionsButton, (option) => option !== '')
              Object.assign(footerButton, filteredOption)
              //Bind url params
              const regex = /:(\w*)/g // @regex matches url param
              const found = regex.exec(footerButton.url)
              if (isArray(found))
                footerButton.url = footerButton.url.replace(found[0], get(window.CORE.params, found[1], found[0]))
            }
          })
        })
      }

      if (this.popupTitle) {
        footerButtons.map((footerButton) => {
          if (footerButton.url.match(/\/create$/)) {
            footerButton.popupTitle = this.popupTitle
          }
          return footerButton
        })
      }

      return footerButtons
    },
  },
  watch: {
    primaryKey: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.buttonsLoad().then(({ data }) => (this.collapsedButtons = data))
        }
      },
    },
  },
}
</script>

<style scoped></style>
